<ng-container *ngIf="type == 'comments'">
  <span class="user-comments c-pointer" (click)="replies.emit(count)">{{ count || 0 }} {{ count == 1 ? "Comment" :
    "Comments" }}</span>
</ng-container>
<ng-container *ngIf="type == 'likes'">
  <span class="user-likes"><span [class.text-danger]="likeArr.includes(userId)" (click)="likeUnlike.emit(true)"><i class="fas fa-heart c-pointer me-1"
        ></i></span>{{ likeArr.length }} {{ likeArr.length == 1 ? "Like" :
    "Likes" }}</span>
</ng-container>